import React, { PropsWithChildren } from "react";
import styles from "./TipValueWithLabel.module.scss";

interface TipValueWithLabelProps {
  label: string;
}

export const TipValueWithLabel: React.FC<
  TipValueWithLabelProps & PropsWithChildren
> = ({ children, label }) => {
  return (
    <div className={styles.infoContainer}>
      <span className={styles.label}>{label}</span>
      <p className={styles.value}>{children}</p>
    </div>
  );
};
